export const women_articles = [
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/3GML2T366RBBBIDG5NKZEYS3DU.jpg",
        article_title: "Lions, Tigers, and Bears, oh my! A guide to the 2025 Ivy League women’s basketball season",
        article_authors: "Jillian Prunty, Alison Chiu",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/lions-tigers-and-bears-oh-my-a-guide-to-the-2025-ivy-league-womens-basketball-season/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/4BA62GLBKVH4RE2Z3AJKRUFS6A.jpg?auth=b14ca238fe817b97b77a7b716805efd133b4ed2131a61005a3da42823c02aace",
        article_title: "Lion cubs: Five new faces join women’s basketball",
        article_authors: "Arielle Rieder, Kaya Quebada",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/lion-cubs-five-new-faces-join-womens-basketball/"
    },
    {
        youtube_link: "https://www.youtube.com/watch?v=efdQ9tg9tWk",
        article_title: "Star power and a historic start: Three things to know as men’s basketball eyes Ivy Madness",
        article_authors: "Arielle Rieder, Elliot Heath, Esmerelda Paredes, Salem Maru",
        article_link: "https://www.youtube.com/shorts/0rtIzZSDlgY"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/V4AYHFIUNBCLBNBXWZJVOS2FRQ.tif?auth=5beb3779ab5ca0cd768313a6c1491021a8b1915d26013d8fdaa252ad2db0236c",
        article_title: "Blau Tor, BC ’27, and María Arrebola, CC ’28, chase the game from Spain to Morningside Heights",
        article_authors: "Ashley Flores",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/blau-tor-bc-27-and-maria-arrebola-cc-28-chase-the-game-from-spain-to-morningside-heights/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/HJVE4GVQLJEDHP4M2A5CBWUJDY.jpg?auth=6bb16816d2d6b33540821d78d278311ec0f891f52fd93410bf28649ee9cb787b",
        article_title:"Women’s basketball makes community connections beyond the court with Harlem Link Charter School",
        article_authors:"Ashley Flores",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/womens-basketball-makes-community-connections-beyond-the-court-with-harlem-link-charter-school/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/3IT2T4C3O5A5LOML5OMS5WOV7E.jpg?auth=f2b88c77b69ecb88bae21813e6f21bec2fd6ea8a85bb18dda9f22ea86808fce4",
        article_title:"Women’s basketball takes down Yale in New Haven",
        article_authors:"Arielle Rieder, Nicholas Fink",
        article_link:"https://www.columbiaspectator.com/sports/2025/01/19/womens-basketball-takes-down-yale-in-new-haven/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/RJPL4XYXB5HTBE6ZRR4RZRHCKA.jpg?auth=25eca73f4370fbc3ffd7cfd938da8e14fc2a9428e58528c5ed8c27e3e271bdaa",
        article_title: "Women’s basketball defeats Princeton, 58-50",
        article_authors: "Arielle Rieder, Jllian Prunty",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/womens-basketball-defeats-princeton-58-50/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/WVYM3X44CFGVFJIKJAYXDJDVO4.jpg?auth=2ae653d2e7e3180ff16c30d13383a2e17dd70c9bd5e2645f6ad794e0d7e8e1df",
        article_title: "How associate head coach Tyler Cordell centers trust and family on the court",
        article_authors: "Olivia Madkins",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/21/how-associate-head-coach-tyler-cordell-centers-trust-and-family-on-the-court/"

    }
];